<div class="table-responsive custom-table-responsive tabla_detalle">
	<table *ngIf="dataTable.data.length; else noDetails" class="table custom-table">
		<thead>
			<tr>
				<th
					scope="col"
					*ngFor="let header of dataTable.headers; let i = index"
					[ngClass]="{ right_moneda: getAlign(i) !== null && getAlign(i) === 'right' }"
					[innerHtml]="header"
				></th>
			</tr>
		</thead>

		<tbody>
			<ng-container *ngFor="let data of dataTable.data | slice: startItem:endItem">
				<tr scope="row">
					<th
						*ngFor="let item of $any(data) | keyvalue: originalOrder; let i = index"
						[ngClass]="{
							right_moneda: getConfig(i) !== null && getConfig(i)!.textAlign === 'right',
							importe_row: getConfig(i) !== null && getConfig(i)!.isImport === true,
							importe_negativo: getConfig(i) !== null && getConfig(i)!.isImport === true && isNegative(item.value)
						}"
					>
						{{ item.value }}
					</th>
				</tr>

				<tr class="spacer">
					<td colspan="100"></td>
				</tr>
			</ng-container>
		</tbody>
	</table>
	<ng-template #noDetails>
		<div class="center_content">
			<h2 class="no_detail">{{ emptyData }}</h2>
		</div>
	</ng-template>
	<app-paginator
		*ngIf="dataTable.data.length > itemsPerPage"
		[itemsLength]="dataTable.data.length"
		[itemsPerPage]="itemsPerPage"
		[newstartpage]="startItem"
		(pageEmitter)="onPageChange($event)"
		[event]="reloadbuttonPage.asObservable()"
	></app-paginator>
</div>
